"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = exports.ThemeProvider = void 0;
const react_1 = require("@chakra-ui/react");
const __1 = require("..");
const foundation_1 = require("./foundation");
var react_2 = require("@chakra-ui/react");
Object.defineProperty(exports, "ThemeProvider", { enumerable: true, get: function () { return react_2.ChakraProvider; } });
exports.theme = (0, react_1.extendTheme)({
    colors: foundation_1.colors,
    components: { Button: __1.Button, Heading: __1.Heading, Input: __1.Input, Tabs: __1.Tabs, Text: __1.Text, Textarea: __1.Textarea },
    fonts: foundation_1.fonts,
    styles: foundation_1.styles,
});
